//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import EventBus from "@/event-bus.js";
import { FIND_TIPO_ENCUESTA_BY_ID } from "@/graphql/queries/encuestas.js";
import BasicEncuesta from "@/components/BasicEncuesta";
import SliderEncuesta from "@/components/SliderEncuesta";

export default {
  name: "ModeloEncuestas",
  components: {
    BasicEncuesta,
    SliderEncuesta
  },
  apollo: {
    tipo_encuesta: {
      query: FIND_TIPO_ENCUESTA_BY_ID,
      variables: {
        id: null
      },
      update(data) {
        if (data.findTipoEncuestaById) {
          if (data.findTipoEncuestaById && data.findTipoEncuestaById.help) {
            EventBus.$emit("dynamic-help", {
              help: data.findTipoEncuestaById.help.html
            });
          }
          return data.findTipoEncuestaById;
        }
        return {};
      },
      skip() {
        return true;
      }
    }
  },
  mounted() {
    EventBus.$emit("page-loaded", { page: "Rapid3Encuesta" });
    this.internalId = +this.$route.params.id;
    this.$apollo.queries.tipo_encuesta.setVariables({
      id_tipo_encuesta: this.internalId
    });
    this.$apollo.queries.tipo_encuesta.skip = false;
    this.$apollo.queries.tipo_encuesta.refetch();
    this.readOnly = false;
  },
  data() {
    return {
      tipo_encuesta: {},
      resultados: [],
      internalId: null,
      resultadoNumerico: 0,
      resultadoFinal: null,
      color: null,
      readOnly: false,
      observaciones: "",
      generalState: null,
      showResultado: false
    };
  },
  watch: {
    encuesta: {
      deep: true,

      // We have to move our method to a handler field
      handler(newParam) {
        if (this.readOnly) {
          this.resultados = newParam.respuestas;
          this.resultadoNumerico = +newParam.resultado_numerico;
          this.resultadoFinal = newParam.resultado;
          this.color = newParam.color;
          this.generalState = !!newParam.observaciones;
        }
        console.log(newParam);
      }
    }
  },
  methods: {
    showResultadoAction() {
      this.showResultado = true;
    }
  }
};
